import { StyleSheet } from '@react-pdf/renderer';

export const sharedStyles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 10,
    fontFamily: 'Helvetica',
    backgroundColor: '#ffffff'
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 30,
    paddingBottom: 20,
    borderBottomWidth: 2,
    borderBottomColor: '#0D47A1'
  },
  logoContainer: {
    flexDirection: 'row',
    gap: 15,
    alignItems: 'center'
  },
  logo: {
    width: 60,
    height: 60,
    objectFit: 'contain'
  },
  businessInfo: {
    flex: 1
  },
  businessName: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#111418',
    marginBottom: 5
  },
  businessDetails: {
    fontSize: 9,
    color: '#617289',
    marginBottom: 2
  },
  documentTitle: {
    textAlign: 'right'
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#0D47A1',
    textTransform: 'uppercase',
    marginBottom: 5
  },
  documentInfo: {
    fontSize: 9,
    color: '#617289',
    textAlign: 'right',
    marginBottom: 2
  },
  section: {
    marginBottom: 20
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#111418',
    marginBottom: 10,
    textTransform: 'uppercase',
    letterSpacing: 0.5
  },
  table: {
    width: '100%',
    marginBottom: 15
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#f0f2f4',
    padding: 8,
    fontWeight: 'bold',
    fontSize: 9,
    textTransform: 'uppercase',
    color: '#111418'
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#e0e0e0',
    padding: 8,
    fontSize: 9
  },
  tableCell: {
    flex: 1,
    textAlign: 'left'
  },
  tableCellCenter: {
    flex: 1,
    textAlign: 'center'
  },
  tableCellRight: {
    flex: 1,
    textAlign: 'right'
  },
  summary: {
    marginTop: 20,
    alignItems: 'flex-end'
  },
  summaryBox: {
    width: 250,
    padding: 15,
    backgroundColor: '#f6f7f8',
    borderRadius: 5
  },
  summaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 5
  },
  summaryLabel: {
    fontSize: 10,
    color: '#617289'
  },
  summaryValue: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#111418'
  },
  summaryTotal: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: 10,
    marginTop: 10,
    borderTopWidth: 2,
    borderTopColor: '#111418'
  },
  summaryTotalLabel: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#111418'
  },
  summaryTotalValue: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#0D47A1'
  },
  notes: {
    marginTop: 30,
    padding: 15,
    backgroundColor: '#f6f7f8',
    borderRadius: 5
  },
  notesTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#111418',
    marginBottom: 8
  },
  notesText: {
    fontSize: 9,
    color: '#617289',
    lineHeight: 1.5
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 40,
    right: 40,
    paddingTop: 15,
    borderTopWidth: 1,
    borderTopColor: '#e0e0e0',
    fontSize: 8,
    color: '#617289',
    textAlign: 'center'
  }
});
